var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomerPrivateWoman2 = function SvgCustomerPrivateWoman2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.462 150.462",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(455.138 287.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.231,
    cy: 75.231,
    r: 75.231,
    fill: "#adcce9",
    "data-name": "Ellipse 7",
    transform: "translate(-455.138 -287.342)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#135899",
    d: "M-344.659-177.034c-16.159-5.825-21.322-2.89-21.322-13.415 0-.5.032-1.446.091-2.412h.791c11.043.8 21.682 1.575 24.049-.08 3.781-2.642-9.307-6.712-9.307-40.887 0-17.268-11.381-29.521-28.649-29.521-.147 0-.291.009-.436.011h-.122v-.011h-.864c-.145 0-.289-.011-.436-.011-17.266.011-28.647 12.264-28.647 29.532 0 34.174-13.088 38.245-9.307 40.887 2.368 1.654 13.007.886 24.05.08h.791c.059.966.09 1.911.09 2.412 0 10.525-5.164 7.59-21.322 13.415-15.133 5.458-20.208 11.014-20.815 15.036a75.03 75.03 0 0 0 56.089 25.111A75.03 75.03 0 0 0-323.845-162c-.607-4.019-5.682-9.576-20.814-15.034",
    "data-name": "Pfad 33"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomerPrivateWoman2);
export default ForwardRef;